<template>
  <div id="app" class="wrapper">
    <navbar />
    <div class="main-content">
      <keep-alive>
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </div>
    <footer class="footer">
      <div>
        <p>Copyright © 2022 - 2026 <strong>Springbit, Inc.</strong></p>
        <router-link to="/privacy">Privacy Policy</router-link>
      </div>
    </footer>
  </div>
</template>
<script>
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Navbar,
  },
};
</script>

<style lang="scss">
html {
  height: 100%;
}

.wrapper {
  display: flex;
  flex-direction: column;
  height: 95vh;
  /* Avoid the IE 10-11 `min-height` bug. */
}

.main-content {
  flex: 1 0 auto;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  padding: 0;
}

.footer {
  flex-shrink: 0;
  /* Prevent Chrome, Opera, and Safari from letting these items shrink to smaller than their content's default minimum size. */
  padding: 100px;
  margin-top: 0px;
}
</style>
